import {autoinject} from "aurelia-framework";
import {Router} from "aurelia-router";
import {Cart, CartService, GiftCard} from "../cart-service";
import {EventAggregator} from 'aurelia-event-aggregator';
import {UpdateShoppingCartMessage} from "../events/update-shopping-cart-message";

@autoinject()
export class Page3Cart {


  private cart: Cart;

  private giftCards: GiftCard[] = [];

  private sum: number = 0;

  constructor(
    private eventAggregator: EventAggregator,
    private router: Router,
    private cartService: CartService) {
    window.scrollTo(0, 0);
  }

  attached() {
    this.cartService.getCart().then(cart => {
      this.cart = cart;
      this.giftCards = cart.giftCards;
    });

    this.sum = this.cartService.getTotalAmount();
    this.eventAggregator.subscribe(UpdateShoppingCartMessage, mesage => {
      this.sum = this.cartService.getTotalAmount()
    })
  }

  private next() {
    this.router.navigate("page4-address")
  }

  private shippingCosts(): string {
    return `${this.cartService.getShippingCostString()} €`
  }

  private goToGiftCardSelection() {
    try {
      NY_TRACKER.trackClick({value: '0', label: 'page3', action: 'addAnotherGiftCard', category: "GiftcardClient"});
    } catch (e) {
      console.log("no tracking inizialized");
    }
    this.router.navigate("page2-amount")
  }

  private quantityValues: number[] = this.generateNumerArray(10);

  private generateNumerArray(value: number): number[] {
    let array: number[] = [];

    for (let i = 1; i < value + 1; i++) {
      array.push(i)
    }
    return array

  }

  private updateCart(giftCard: GiftCard) {
    this.eventAggregator.publish(new UpdateShoppingCartMessage());

    try {
      NY_TRACKER.trackClick({
        value: (giftCard.count).toString(),
        label: 'page3',
        action: 'giftCardQuantityChanged',
        category: "GiftcardClient"
      })
    } catch (e) {
      console.log("no tracking inizialized");
    }

  }

  private deleteGiftCard(giftCard: GiftCard) {

    let removeIndex = this.cart.giftCards.indexOf(giftCard);

    // create new array to prevent aurelia array bug
    let newArray = [];

    for (let i = 0; i < this.cart.giftCards.length; i++) {
      if (i != removeIndex) {
        const giftCardElement = this.cart.giftCards[i];
        newArray.push(giftCardElement)
      }
    }

    this.cart.giftCards = newArray;
    this.eventAggregator.publish(new UpdateShoppingCartMessage());

    try {
      NY_TRACKER.trackClick({
        value: (giftCard.count * giftCard.amount).toString(),
        label: 'page3',
        action: 'giftCardDeleted',
        category: "GiftcardClient"
      })
    } catch (e) {
      console.log("no tracking inizialized");
    }

  }

}